<template functional>
  <div class="card" itemscope itemtype="https://schema.org/CreativeWork">
    <div class="imgContainer">
      <img :src="props.icon" :alt="props.iconAlt" />
    </div>
    <h2 class="fs-m">{{ props.title }}</h2>
    <p class="fs-s" v-html="props.description"></p>
  </div>
</template>

<script>
export default {
  name: "ProductGridCard",
  props: {
    icon: String,
    iconAlt: String,
    title: String,
    description: String
  }
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;

  flex-direction: column;

  align-items: center;

  .imgContainer {
    display: flex;

    width: 8rem;
    height: 8rem;

    align-items: center;

    margin-bottom: 1rem;
  }

  img {
    width: 100%;
  }

  h2 {
    margin-bottom: 1rem;
  }
}
</style>
